/**
 * Unwraps axiosInstance results: { success, data: serverJson } and common
 * list shapes: { data: [] }, nested { data: { data: [] } }.
 */
export const parseListFromApiResponse = (response) => {
  if (!response || response.success !== true) return [];
  const body = response.data;
  if (body && body.success === false) return [];
  if (Array.isArray(body)) return body;
  if (Array.isArray(body?.data)) return body.data;
  if (Array.isArray(body?.data?.data)) return body.data.data;
  if (Array.isArray(body?.transactions)) return body.transactions;
  if (Array.isArray(body?.results)) return body.results;
  return [];
};

export const valueFromSettled = (settled) =>
  settled?.status === "fulfilled" ? settled.value : null;
